import * as axios from 'axios';
import * as Utils from "./index"; 


const axiosInstance = axios.create({
    baseURL: Utils.api_url,
    headers: {}
});



// Request interception
axiosInstance.interceptors.request.use(
    async function (config) { 
        return config;
      }, function (error) {
          console.log(error.response);
        // Do something with request error
        return Promise.reject(error);
    }
);

// Response Interception
axiosInstance.interceptors.response.use(
    function (response) {
        console.log("Response intercepted");
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, function (error) {
  

        const status = error.response.status;

        if(status === 0) {

            alert("Vérifiez votre connexion internet")

        } else if (status === 400) {

            alert('Bad form.')


        } else if (status === 403 || status === 401) {

            alert('Votre connexion a expiré.')


        }  else {
            alert("Une erreur s\'est produite réesseyez s\'il vous plaît.")
        }

         
      
        return Promise.reject(error);
    }
);  

export default axiosInstance;